import { render, staticRenderFns } from "./TabsNavigation.vue?vue&type=template&id=b173831c&"
import script from "./TabsNavigation.vue?vue&type=script&lang=js&"
export * from "./TabsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TabsNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports